export enum ETypeFichier {
    Pdf = 1,
    Image = 2,
    Video = 3,
    Autre = 99
}